import Component from '../abstracts/Component';

export default class SearchGuestOrderComponent extends Component {

  get SELECTORS() {
    return {
      btnSearch: '.js-search-guest-order',
      inputEmail: '#LoginForm input[type="email"]',
      inputPwd: '#LoginForm input[type="password"]',
      submitBtn: '#LoginForm button[type="submit"]'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.inputEmail = this.$component.querySelector(this.SELECTORS.inputEmail);
    this.inputPwd = this.$component.querySelector(this.SELECTORS.inputPwd);
    this.submitBtn = this.$component.querySelector(this.SELECTORS.submitBtn);
  }

  searchOrderSubmit() {

    //ajax submit of search order form to manage errors
    const ctx=this;
    $('body').on('click.search-order', ctx.SELECTORS.btnSearch,function (e) {
      e.preventDefault();
      let formSearchOrder = this.closest('form');
      const formData = ctx.getFormData(formSearchOrder);
      let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + '/guest/return-request?search-guest-order=true',
        data: formData,
        method: 'POST',
        success: function (response) {
          if(response.hasError){
            $('.js-error-notification').removeClass('d-none');
            $(formSearchOrder).find('input').addClass('error');
          } else {
            $('.js-error-notification').addClass('d-none');
            $(formSearchOrder).find('input').removeClass('error');
            $(formSearchOrder).submit();
          }
        }
      })
    });

  }

  getFormData(formSearchOrder) {
    return $(formSearchOrder).serialize();
  }

  bindEvents() {
    let ctx = this;

    this.inputEmail.addEventListener('input', (e) => {
      if (ctx.inputEmail.value !== '' && ctx.inputPwd.value !== '') {
        ctx.submitBtn.removeAttribute('disabled');
        ctx.submitBtn.classList.remove('disabled');
      } else {
        ctx.submitBtn.setAttribute('disabled', 'disabled');
        ctx.submitBtn.classList.add('disabled');
      }
    });
    this.inputPwd.addEventListener('input', (e) => {
      if (ctx.inputEmail.value !== '' && ctx.inputPwd.value !== '') {
        ctx.submitBtn.removeAttribute('disabled');
        ctx.submitBtn.classList.remove('disabled');
      } else {
        ctx.submitBtn.setAttribute('disabled', 'disabled');
        ctx.submitBtn.classList.add('disabled');
      }
    });
  }

  render() {
    super.render();
    this.searchOrderSubmit();
    this.bindEvents();
  }
}
